import React, { useState } from "react";
import styles from "../Dashboard/Order/OrderModal/users.module.css";
import { RxCross1 } from "react-icons/rx";
import { FaShopLock } from "react-icons/fa6";// import OrderStatus from "./OrderStatus";
// import OrderChat from "./OrderChat";
import { useSelector } from "react-redux";
import OrderDetails from "../Dashboard/Order/OrderModal/OrderDetails";
import OrderInvoice from "../Dashboard/Order/OrderModal/OrderInvoice";
import OrderStatus from "../Dashboard/Order/OrderModal/OrderStatus";
import OrderChat from "../Dashboard/Order/OrderModal/OrderChat";
import PromocodeInfo from "./PromocodeModal/PromocodeInfo";
import PromocodeFor, { PromocodFor } from "./PromocodeModal/PromocodeFor";

const PromocodeDetails = ({
  handleCloseOrderModal,
  isOrderDetail,
  promocodeData,
}) => {
  const [toggleContent, setToggleContent] = useState("Details");
  console.log("promocodeData", promocodeData);

  const { theme } = useSelector((state) => state.theme);
  if (isOrderDetail) {
    return (
      <>
        <div className={styles.main}>
          <div
            className={`${styles.container} ${
              theme === "light"
                ? "bg-secondaryColor text-textColorLight"
                : "bg-darkThirsary text-darkSecondary"
            } `}
          >
            <div className={`${styles.header_div} `}>
              <div>
                <span style={{ fontSize: "1.4rem" }}>Promocode Details</span>
                <div className="flex gap-1 px-3 py-2 rounded-md bg-gray-100   items-center justify-center w-fit">
                  <FaShopLock className="text-[#145388] text-lg" />
                  <p className="w-fit rounded-md font-semibold text-[#145388]">
                    {promocodeData?.created_by?.first_name}
                  </p>
                </div>
              </div>

              <RxCross1
                size={"1rem"}
                onClick={() => handleCloseOrderModal()}
                cursor={"pointer"}
              />
            </div>

            {/* <hr /> */}
            <div style={{ display: "flex", marginBottom: "1rem" }}>
              {["Details", "Applied", "Usage", "Chat"].map((item) => (
                <hr
                  style={{
                    width: "25%",
                    borderTop:
                      item === toggleContent ? "5px solid  " : "1px solid",
                    color:
                      item === toggleContent
                        ? "rgb(15 61 100 / var(--tw-text-opacity)"
                        : "var(--light-color3)",
                    borderRadius: "10px",
                    borderBottom: "none",
                    borderLeft: "none",
                    borderRight: "none",
                  }}
                />
              ))}
            </div>

            <div className={`${styles.content_list}  border-black-700 `}>
              {["Details", "Applied", "Usage", "Chat"].map((item) => (
                <span
                  onClick={() => setToggleContent(item)}
                  style={{
                    color:
                      item === toggleContent
                        ? "var(--color--2) "
                        : "var(--light-color3)",
                    cursor: "pointer",
                  }}
                >
                  {item}
                </span>
              ))}
            </div>
            <hr />
            {toggleContent === "Details" && (
              <PromocodeInfo
                promoData={promocodeData}
                orderDetails={promocodeData?.orderDetails}
              />
            )}
            {toggleContent === "Applied" && (
              <PromocodFor promo={promocodeData} />
            )}
            {toggleContent === "Usage" && (
              <OrderStatus orderStatus={promocodeData?.orderStatus} />
            )}
            {toggleContent === "Chat" && <OrderChat />}
          </div>
        </div>
      </>
    );
  }
};

export default PromocodeDetails;



